export const VERSION_UPDATE_AVAILABLE = 'VERSION_UPDATE_AVAILABLE';
